import { CoachProfileView } from '@efdigital/ll-addon-coaching';
import type {
  CoachingPartnership,
  CoachProfile,
} from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import { type CoachProfileWithRelevance } from '@efdigital/ll-xceed-v2/components/coaching/coachee/coaches-browse.gts';
import type CoachingCoacheeCohortCoachesIndexController from '@efdigital/ll-xceed-v2/controllers/coaching/coachee/cohort/coaches/index';
import { queryCoachProfilesByPartnerships } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { Request } from '@warp-drive/ember';
import { pageTitle } from 'ember-page-title';

interface CoachesSelectedSignature {
  Args: {
    model: CoachingCoacheeCohortModel;
    controller: CoachingCoacheeCohortCoachesIndexController;
  };
}

const None = <template>
  <Heading
    @size="sm"
    @text="Your Chosen Coach"
    @secondary="No coach has been chosen yet."
  />

  <EmptyState
    @message="You have not chosen a coach yet. Please shortlist a coach and book a chemistry session with them to decide if they are the right fit for you."
  />
</template>;

export default class CoachesSelected extends Component<CoachesSelectedSignature> {
  coachesWithRelevance(
    coachProfiles: CoachProfile[]
  ): CoachProfileWithRelevance[] {
    return coachProfiles.map((coachProfile) => ({
      coachProfile,
      relevance: 0,
    }));
  }

  queryShortlist(partnerships: CoachingPartnership[]) {
    return queryCoachProfilesByPartnerships(partnerships);
  }

  <template>
    {{pageTitle "Selected"}}

    <div class={{PAGE_WRAPPER_CONTENT}}>
      {{#if @model.planner.chosenPartnerships.length}}

        <Request
          @query={{this.queryShortlist @model.planner.chosenPartnerships}}
        >
          <:content as |coachProfiles|>
            {{#let
              (this.coachesWithRelevance coachProfiles.data)
              as |coachProfiles|
            }}
              {{#if coachProfiles.length}}
                <Heading
                  @size="sm"
                  @text="Your Chosen Coach"
                  @secondary="This is the coach you have chosen for your coaching journey."
                />
                {{#each coachProfiles as |match|}}
                  <CoachProfileView
                    class="ll-coach-profile-view"
                    @coach={{match.coachProfile}}
                    @partnershipStatus={{@model.planner.getStatusForCoach
                      match.coachProfile.user
                    }}
                  >
                    <:actions>
                      <div class="my-4 text-center">
                        <LinkTo
                          @route="coaching.coachee.cohort.sessions"
                          @models={{array @model.program_id @model.cohort_id}}
                          class="btn btn-outline-primary shadow"
                        >Coaching sessions
                          <iconify-icon
                            icon="ph:arrow-right-bold"
                            inline
                            aria-hidden="true"
                          /></LinkTo>
                      </div>
                    </:actions>
                  </CoachProfileView>
                {{/each}}
              {{else}}
                <None />
              {{/if}}
            {{/let}}
          </:content>
        </Request>
      {{else}}
        <None />
      {{/if}}
    </div>
  </template>
}
